<template>
  <v-row>
    <v-col cols="12" :class="{ 'col-sm8' : !this.canCreateAJointPlan, 'pa-0': $vuetify.breakpoint.smAndDown }">
      <v-card flat :outlined="$vuetify.breakpoint.mdAndUp">
        <v-container class="py-0">
          <v-row>
            <v-col cols="12" sm="4" class="summary-left px-12">
              <v-row>
                <v-col cols="12">
                  <div :class="{ 'summary-title big' : $vuetify.breakpoint.mdAndUp, 'summary-title': $vuetify.breakpoint.smAndDown }">{{ summary.left | currency}}</div>
                  <div class="ok-title">{{ $t('ds-text-1') }}</div>
                </v-col>
                <v-col cols="12">
                  <div class="mr-6 d-inline-block">
                    <div class="summary-title ">{{ countDebts }} {{ $t('kpl') }}</div>
                    <div class="ok-title">
                      <span class="mr-2">{{ $t('ds-text-2') }}</span>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="grey"
                                  dark
                                  v-bind="attrs"
                                  v-on="on">fas fa-info-circle</v-icon>
                        </template>
                        <span>{{ $t('ds-text-11') }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                  <div class="d-inline-block">
                    <div class="summary-title">{{ countDebtsWithoutPaymentPlan }} {{ $t('kpl') }}</div>
                    <div class="ok-title">
                      <span class="mr-2">{{ $t('ds-text-3') }}</span>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="grey"
                                  dark
                                  v-bind="attrs"
                                  v-on="on">fas fa-info-circle</v-icon>
                        </template>
                        <span>{{ $t('ds-text-4') }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" v-if="countDebts > 0">
                  <v-btn :block="$vuetify.breakpoint.smAndDown" to="/pay-all" tile color="primary">{{ $t('ds-text-5') }}</v-btn>
                </v-col>
                <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown && canCreateAJointPlan">
                  <v-btn block tile outlined dark color="color-new-link-blue" @click="paymentPlanButtonClick">{{ $t('createPaymentPlan') }}</v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="8" class="summary-right" v-if="$vuetify.breakpoint.mdAndUp">
              <v-row class="fill-height">
                <v-col cols="12" sm="6" class="text-center" v-if="canCreateAJointPlan">
                  <v-icon color="color-grey" class="large-icon">fas fa-info-circle</v-icon>
                  <h4 class="mt-4 text-h4">{{ $t('createPaymentPlan') }}</h4>
                  <p>{{ $t('ds-text-6') }}</p>
                  <v-btn tile outlined dark color="color-new-link-blue" @click="paymentPlanButtonClick">{{ $t('ds-text-7') }}</v-btn>
                </v-col>
                <v-col cols="12" :class="{ 'col-sm-6' : this.canCreateAJointPlan }" class="text-center">
                  <v-icon color="color-grey" class="large-icon">fas fa-info-circle</v-icon>
                  <h4 class="mt-4 text-h4">{{ $t('ds-text-8') }}</h4>
                  <p>{{ $t('ds-text-9') }}</p>
                  <v-btn text color="color-new-link-blue" to="/help">{{ $t('ds-text-10') }}</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    computed: {
      summary () {
        return this.$store.getters.summary
      },
      canCreateAJointPlan () {
        return this.$store.getters.canCreateAJointPlan
      },
      countDebts () {
        return this.$store.getters.openDebts.length
      },
      countDebtsWithoutPaymentPlan () {
        return this.$store.getters.openDebts.length - this.$store.getters.openDebtsWithoutPaymentPlan.length
      }
    },
    methods: {
      paymentPlanButtonClick () {
        this.$store.commit('setFrontPageActiveTab', 'tab-paymentplan')
        var element = document.getElementById('frontPageTabs')
        if (element) {
          var top = element.offsetTop
          window.scrollTo(0, top)
        }
      }
    }
  }
</script>

<style>
  .summary-left { border-bottom: none; padding-top: 1rem; padding-bottom: 1rem; }

  @media (min-width: 768px) {
    .summary-left { border-right: 1px solid lightgrey; }
  }

  .v-icon.large-icon { font-size: 3em; }
  .summary-title { font-size: 2.4375rem; }
  .summary-title.big { font-size: 3.25rem; }
</style>

<i18n>
  {
  "fi": {
  "ds-text-1": "Velkojen kokonaismäärä",
  "ds-text-2": "Velkoja",
  "ds-text-3": "Suunnitelmaa",
  "ds-text-4": "Montako maksusuunnitelmaa sinulla on",
  "ds-text-5": "Maksa kertamaksulla",
  "ds-text-6": "Voit helpottaa velkojesi hoitoa yhdistämällä ne yhteisen maksusuunnitelman alle, ja lyhentää niitä valitsemallasi aikataululla.",
  "ds-text-7": "Aloita tästä",
  "ds-text-8": "Ohjeet & vinkit",
  "ds-text-9": "Olemme koonneet useimmin kysyttyjä kysymyksiä & ohjeita velka-asioiden hoitoon.",
  "ds-text-10": "Tutustu tarkemmin",
  "ds-text-11": "Velkojesi kappalemäärä. Perinnässä voi lisäksi olla velkoja joita emme voi näyttää Oma B2 Impact palvelussa."
  },
  "se": {
  "ds-text-1": "Skuldernas totalsumma",
  "ds-text-2": "Skulder",
  "ds-text-3": "Betalningsplaner",
  "ds-text-4": "Antal betalningsplaner",
  "ds-text-5": "Betala",
  "ds-text-6": "Du kan underlätta hanteringen av dina skulder genom att kombinera dem till en betalningsplan och betala i en takt som passar dig.",
  "ds-text-7": "Börja här",
  "ds-text-8": "Frågor & svar",
  "ds-text-9": "Här hittar du svar på de vanligaste frågorna om inkasso.",
  "ds-text-10": "Läs mer",
  "ds-text-11": "Antal skulder. Du kan ha fler skulder i inkasso som vi inte kan visa i Min B2 Impact tjänsten"
  },
  "en": {
  "ds-text-1": "Total debts",
  "ds-text-2": "Debts",
  "ds-text-3": "Payment plans",
  "ds-text-4": "How many payment plans you have",
  "ds-text-5": "Pay with a single payment",
  "ds-text-6": "You can ease the management of your debts by combining them into one payment plan and pay at a pace that suits you the best.",
  "ds-text-7": "Start here",
  "ds-text-8": "Help & tips",
  "ds-text-9": "Here you can find the answers to the most common questions about collection.",
  "ds-text-10": "Read more",
  "ds-text-11": "Number of debts. You can have more debts in collection that we can not show in the My B2 Impact service"
  }
  }
</i18n>
